'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cardNumber = require('./card-number');

var _cardNumber2 = _interopRequireDefault(_cardNumber);

var _cardExpiration = require('./card-expiration');

var _cardExpiration2 = _interopRequireDefault(_cardExpiration);

var _cardSecurityCode = require('./card-security-code');

var _cardSecurityCode2 = _interopRequireDefault(_cardSecurityCode);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # Credit Card Input Set
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * A way to instantiate multiple credit card inputs at once.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new Spark.Payments.UnifiedCreditCard(el, {...});
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/payments/unified-credit-card.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var onValidEvent = document.createEvent('Event');
var onInvalidEvent = document.createEvent('Event');

onValidEvent.initEvent('valid', true, true);
onInvalidEvent.initEvent('invalid', true, true);

var CardSet = function (_BaseComponent) {
  _inherits(CardSet, _BaseComponent);

  /**
   * CardSet constructor.
   * @param {Element} el
   * @param {Object} params
   */
  function CardSet(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, CardSet);

    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params));

    _this._bindEventListenerCallbacks();
    _this._addEventListeners();
    return _this;
  }

  /**
   * Sets up references
   * @param {Element} el base DOM element
   * @param {Object} params
   */


  CardSet.prototype._cacheElements = function _cacheElements(el, params) {
    var _this2 = this;

    this.el = el;

    if (!this.el) {
      throw new Error('CardSet markup missing');
    } else {
      this.number = new _cardNumber2.default(this.el.querySelector('.spark-payment--card-number'), {
        onInput: this._onInput.bind(this),
        onBlur: this._onBlur.bind(this),
        onFocus: this._onFocus.bind(this),
        onCardType: this._onCardType.bind(this),
        cardTypes: params.cardTypes,
        onInvalid: function onInvalid() {
          onInvalidEvent.input = _this2.number;
          _this2.el.dispatchEvent(onInvalidEvent);
        }
      });
      this.expiration = new _cardExpiration2.default(this.el.querySelector('.spark-payment--expiration'), {
        onInput: this._onInput.bind(this),
        onBlur: this._onBlur.bind(this),
        onFocus: this._onFocus.bind(this),
        onInvalid: function onInvalid() {
          onInvalidEvent.input = _this2.expiration;
          _this2.el.dispatchEvent(onInvalidEvent);
        }
      });
      this.securityCode = new _cardSecurityCode2.default(this.el.querySelector('.spark-payment--card-security-code'), {
        onInput: this._onInput.bind(this),
        onBlur: this._onBlur.bind(this),
        onFocus: this._onFocus.bind(this),
        info: params.info,
        onInvalid: function onInvalid() {
          onInvalidEvent.input = _this2.securityCode;
          _this2.el.dispatchEvent(onInvalidEvent);
        }
      });
      this.components = [this.number, this.expiration, this.securityCode];
    }
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  CardSet.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._onInvalidBound = this._onInvalid.bind(this);
    this._onValidBound = this._onValid.bind(this);
  };

  /**
   * Add event listeners for DOM events.
   */


  CardSet.prototype._addEventListeners = function _addEventListeners() {
    this.el.addEventListener('invalid', this._onInvalidBound, false);
    this.el.addEventListener('valid', this._onValidBound, false);
  };

  /**
   * Remove event listeners for DOM events..
   */


  CardSet.prototype._removeEventListeners = function _removeEventListeners() {
    this.el.removeEventListener('invalid', this._onInvalidBound, false);
    this.el.removeEventListener('valid', this._onValidBound, false);
    this.components.every(function (component) {
      return component._removeEventListeners();
    });
  };

  /**
   * Called when the Card Number field recognizes a new type of card,
   * and used to update the max length of the CVV field
   */


  CardSet.prototype._onCardType = function _onCardType() {
    var type = this.number._cardTypes[this.number.type];
    this.securityCode.maxLength = type.cvv;
    this.onCardType.call(this);
  };

  /**
   * onInput callback for running validation
   */


  CardSet.prototype._onInput = function _onInput() {
    if (this.valid) {
      this.el.dispatchEvent(onValidEvent);
    }
    this.onInput.call(this);
  };

  /**
   * onBlur callback, for firing provided callback
   */


  CardSet.prototype._onBlur = function _onBlur() {
    this.onBlur.call(this);
  };

  /**
   * onFocus callback, for firing provided callback
   */


  CardSet.prototype._onFocus = function _onFocus() {
    this.onFocus.call(this);
  };

  /**
   * onInvalid method for firing provided callback
   * @param {Event} e
   */


  CardSet.prototype._onInvalid = function _onInvalid(e) {
    this.onInvalid.call(this, e);
  };

  /**
   * onValid method for firing provided callback
   */


  CardSet.prototype._onValid = function _onValid() {
    this.onValid.call(this);
  };

  /**
   * Getter for Primary Component Values
   * @return {Object}
   */


  /**
   * Default validate function. This can be overridden by passing a
   * custom validate method as a parameter.
   */
  CardSet.prototype.validate = function validate() {
    this.onValidate(this.valid, this.value, this);
    return this;
  };

  /**
   * Show the inputs by adding the active state.
   */


  CardSet.prototype.show = function show() {
    this.components.every(function (component) {
      return component.show();
    });
    return this;
  };

  /**
   * Hide the inputs by removing the active state.
   */


  CardSet.prototype.hide = function hide() {
    this.components.every(function (component) {
      return component.hide();
    });
    return this;
  };

  /**
   * Returns the current values
   * @return {Object}
   */


  CardSet.prototype.getValue = function getValue() {
    return this.value;
  };

  /**
   * Set the value of the input.
   * @param {Object} values
   */


  CardSet.prototype.setValue = function setValue() {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.value = values;
    return this;
  };

  /**
   * Clear the value of the input.
   */


  CardSet.prototype.clearValue = function clearValue() {
    this.components.every(function (component) {
      return component.value = '';
    });
    return this;
  };

  /**
   * Disable the input.
   */


  CardSet.prototype.disable = function disable() {
    this.components.every(function (component) {
      return component.disable();
    });
    return this;
  };

  /**
   * Enable the input.
   */


  CardSet.prototype.enable = function enable() {
    this.components.every(function (component) {
      return component.enable();
    });
    return this;
  };

  /**
   * Remove component from DOM.
   * @param {Boolean} leaveElement
   */


  CardSet.prototype.remove = function remove(leaveElement) {
    this.components.every(function (component) {
      return component.remove(leaveElement);
    });
    return _BaseComponent.prototype.remove.call(this, leaveElement);
  };

  /**
   * Update the element in use and the position.
   * @param {Element} el
   * @param {Object} params
   */


  CardSet.prototype.update = function update(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this._removeEventListeners();
    this.components.every(function (component) {
      return component.remove(true);
    });
    this._cacheElements.call(this, el || this.el, params);
    this._addEventListeners();
    return this;
  };

  _createClass(CardSet, [{
    key: 'value',
    get: function get() {
      return {
        number: this.number.value,
        expiration: this.expiration.value,
        securityCode: this.securityCode.value
      };
    }

    /**
     * Setter for Primary Component Values
     * @param {Object} values
     */
    ,
    set: function set() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.number.value = values.number || this.number.value;
      this.expiration.value = values.expiration || this.expiration.value;
      this.securityCode.value = values.securityCode || this.securityCode.value;

      if (this.components.some(function (component) {
        return component.value;
      }) && this.valid) {
        this.el.dispatchEvent(onValidEvent);
      } else if (this.components.some(function (component) {
        return component.value;
      })) {
        this.el.dispatchEvent(onInvalidEvent);
      }
    }

    /**
     * Getter for Valid state, returns true if component value is valid, false if not
     * @return {Boolean}
     */

  }, {
    key: 'valid',
    get: function get() {
      return this.components.every(function (component) {
        return component.valid;
      });
    }
  }]);

  return CardSet;
}(_base2.default);

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */


CardSet.prototype.defaults = {
  el: null,
  number: {},
  expiration: {},
  securityCode: {},
  onCardType: function onCardType() {},
  onInput: function onInput() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onValid: function onValid() {},
  onInvalid: function onInvalid() {},
  onValidate: function onValidate() {},
  validate: function validate() {}
};

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */
CardSet.prototype._whitelistedParams = ['onCardType', 'onInput', 'onBlur', 'onFocus', 'onValid', 'onInvalid', 'onValidate', 'validate'];

exports.default = CardSet;
module.exports = exports['default'];
//# sourceMappingURL=card-set.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/components/payments/card-set.js
// module id = 1799
// module chunks = 0